<template>
  <DialogTemplate data-gwmenu="noclose">
    <div class="text-large weight_700 clr-primary">
      {{ $t('common.import_setting') }}
    </div>

    <ImportSolfigrTree
      ref="form"
      style="max-width: 100vw"
      class="import-preset-form mt-2"
      :namespace="namespace"
      @success="loading = true"
    />

    <template #dialog_actions>
      <v-btn
        id="trainer-settings-btn-close"
        variant="text"
        class="ml-auto mr-2"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
      <portal-target name="dialog_actions"></portal-target>
    </template>
  </DialogTemplate>
</template>

<script>
import ImportSolfigrTree from '@/components/Dialogs/ImportDialogs/ImportSolfigrTree'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'ImportSolfigrTreeDialog',
  components: {
    ImportSolfigrTree,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'import-solfigr-tree-dialog')
    },
    apply() {
      this.$refs.form.apply()
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .import-preset-form {
    margin-top: 1.5rem;
  }
}
</style>
